import React from 'react'
import { useLocation, Link as RouterLink } from 'react-router-dom'
import { Breadcrumbs, Link, Typography } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import routes from '../../routes'

/**
 * Migas de pan del header a partir de las rutas de la aplicación
 */
const Breadcrumb = () => {
  const currentLocation = useLocation().pathname

  const getRouteName = (pathname, routes) => {
    const matchingRoute = routes.find((route) => {
      const routePathSegments = route.path.split('/');
      const pathnameSegments = pathname.split('/');

      if (routePathSegments.length !== pathnameSegments.length) {
        return false;
      }

      let routeNameWithParam = '';

      for (let i = 0; i < routePathSegments.length; i++) {
        if (routePathSegments[i] !== pathnameSegments[i] && !routePathSegments[i].startsWith(':')) {
          return false;
        }

        if (routePathSegments[i].startsWith(':')) {
          // Si el segmento de ruta comienza con ':', es un parámetro dinámico
          const paramValue = pathnameSegments[i]; // Obtenemos el valor del parámetro
          routeNameWithParam += `${paramValue}`;
        }

        if (i < routePathSegments.length - 1) {
          routeNameWithParam += ' ';
        }
      }

      route.nameWithParam = routeNameWithParam; // Agregar la propiedad al objeto de ruta

      return true;
    });

    return matchingRoute ?  matchingRoute.name + matchingRoute.nameWithParam : false;
  };

  const getBreadcrumbs = (location) => {
    const breadcrumbs = []
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`
      const routeName = getRouteName(currentPathname, routes)
      routeName &&
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length ? true : false,
        })
      return currentPathname
    })
    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)

  return (
    <Breadcrumbs
      aria-label="migas de pan"
      separator={<NavigateNextIcon sx={{ fontSize: 14 }} />}
      sx={{
        '& .MuiBreadcrumbs-separator': { mx: 0.5, color: '#adb5bd' },
      }}
    >
      {breadcrumbs.map((breadcrumb, index) => (
        breadcrumb.active ? (
          <Typography
            key={index}
            sx={{ fontSize: 13, fontWeight: 600, color: '#212529' }}
          >
            {decodeURIComponent(breadcrumb.name)}
          </Typography>
        ) : (
          <Link
            key={index}
            component={RouterLink}
            to={breadcrumb.pathname}
            underline="hover"
            sx={{
              fontSize: 13,
              color: '#6c757d',
              '&:hover': { color: '#cc071e' },
            }}
          >
            {decodeURIComponent(breadcrumb.name)}
          </Link>
        )
      ))}
    </Breadcrumbs>
  )
}

export default React.memo(Breadcrumb)
